import { MeResponse, PlanName } from 'base/accounts_service';
import { AccountStore } from 'base/account_store';
import { Button } from 'base/ui/button';
import { Rows } from 'base/ui/layout';
import { DividerLine } from 'base/ui/panel';
import { TextMedium, TextRegular, TextTinyLight } from 'base/ui/typography';
import {
  authRouteToUrl,
  getCurrentLocationForRedirect,
} from 'blocks/auth/routes';
import { currentUrl } from 'blocks/current_url';
import { observer } from 'mobx-react-lite';
import React from 'react';
import styles from './footer.css';
import loyaltyDayOne from './loyalty-images/day-one.file.svg';
import loyaltyElder from './loyalty-images/elder.file.svg';
import loyaltyExpert from './loyalty-images/expert.file.svg';
import loyaltyMaster from './loyalty-images/master.file.svg';
import loyaltyNewbie from './loyalty-images/newbie.file.svg';

export const Footer = observer(function _Footer({
  accountStore,
}: {
  accountStore: AccountStore;
}) {
  const me = accountStore.member;
  if (!me) {
    return null; // hide while loading or logged out
  }
  if (me.planName === PlanName.FREE) {
    return <FreeUserFooter />;
  }
  return <PaidUserFooter me={me} />;
});

const FreeUserFooter = observer(function _FreeUserFooter() {
  let copy: React.ReactNode;
  if (currentUrl.pathname.includes('figma-library')) {
    copy = 'Get access to 1k+ Figma components';
  } else if (
    currentUrl.pathname.includes('react/') ||
    currentUrl.pathname.includes('react-components/') ||
    currentUrl.pathname.includes('react-categories/')
  ) {
    copy = 'Get access to 1k+ React components';
  } else if (currentUrl.pathname.includes('components')) {
    copy = 'Get access to 1k+ Webflow components';
  } else {
    return null;
  }
  return (
    <Rows spacing={8}>
      <Button
        variant="primary"
        label="Upgrade Plan"
        href={authRouteToUrl({
          path: 'upgrade',
          context: { redirect: getCurrentLocationForRedirect() },
        })}
        gradient
      />
      <TextTinyLight color="grey" align="center">
        {copy}
      </TextTinyLight>
    </Rows>
  );
});

const PaidUserFooter = observer(function _PaidUserFooter({
  me,
}: {
  me: MeResponse;
}) {
  const { daysSubscribed } = me;

  const loyaltyLevel = getLoyaltyLevel(daysSubscribed);
  const loyalty = loyaltyLevel && (
    <>
      <DividerLine />
      <div className={styles.loyalty}>
        <div
          className={styles.loyaltyBadge}
          style={{ backgroundImage: `url(${loyaltyLevel.image})` }}
        >
          <TextMedium>{daysSubscribed}</TextMedium>
        </div>
        <div className={styles.loyaltyText}>
          <TextRegular>{loyaltyLevel.title}</TextRegular>
          <TextTinyLight color="grey">
            Your support means the
            <br />
            world to our small team
          </TextTinyLight>
        </div>
      </div>
    </>
  );
  return <Rows spacing={16}>{loyalty}</Rows>;
});

function getLoyaltyLevel(
  days: number | null | undefined,
): { image: string; title: string } | undefined {
  if (days == null || days <= 0) {
    return;
  }
  if (days === 1) {
    return { title: 'Newbie Lumer', image: loyaltyDayOne };
  }
  if (days < 100) {
    return { title: 'Newbie Lumer', image: loyaltyNewbie };
  }
  if (days < 360) {
    return { title: 'Expert Lumer', image: loyaltyExpert };
  }
  if (days < 720) {
    return { title: 'Master Lumer', image: loyaltyMaster };
  }
  return { title: 'Elder Lumer', image: loyaltyElder };
}
